// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1BackupSettings
 */
export interface V1BackupSettings {
  /**
   * BackupMemoryOverride overrides default memory allocated to the backup job
   * @type {string}
   * @memberof V1BackupSettings
   */
  backupMemoryOverride?: string;
  /**
   * CheckConsistency controls whether to perform consistency checks after a backup. Default: `true`.
   * @type {boolean}
   * @memberof V1BackupSettings
   */
  checkConsistency?: boolean;
  /**
   * ConcurrencyLimit controls how many backup jobs can run in parallel
   * @type {number}
   * @memberof V1BackupSettings
   */
  concurrencyLimit?: number;
  /**
   * ConcurrencyPolicy controls whether concurrent backups are allowed. Default: `AllowConcurrent`.
   * @type {string}
   * @memberof V1BackupSettings
   */
  concurrencyPolicy?: string;
  /**
   * FailedBackupsHistoryLimit specifies how many failed backup jobs and their PVCs to keep after
   * backup completion. Useful for debugging purposes.
   * @type {number}
   * @memberof V1BackupSettings
   */
  failedBackupsHistoryLimit?: number;
  /**
   * If set to `true`, always do a "full" backup i.e. not incremental. Default: `false`.
   * @type {boolean}
   * @memberof V1BackupSettings
   */
  forceFullBackup?: boolean;
  /**
   * FrequencyMinutes controls scheduled backups frequency (minutes).
   * @type {number}
   * @memberof V1BackupSettings
   */
  frequencyMinutes?: number;
  /**
   * Interval between scheduled backups with full storage retention. Defaults to 1440 minutes.
   * @type {number}
   * @memberof V1BackupSettings
   */
  fullRetentionBackupIntervalMinutes?: number;
  /**
   * GDS backup timeout in minutes. Defaults to FrequencyMinutes
   * @type {number}
   * @memberof V1BackupSettings
   */
  gdsTimeoutMinutes?: number;
  /**
   * RetentionDays specifies how many days of completed backups should be retained in the `completedScheduled` and
   * `completedAdHoc` of the BackupSchedule.
   * @type {number}
   * @memberof V1BackupSettings
   */
  retentionDays?: number;
  /**
   * RunBackupDiagnostics determines whether to run and upload diagnostics (e.g. JFR async profiler) during a backup
   * @type {boolean}
   * @memberof V1BackupSettings
   */
  runBackupDiagnostics?: boolean;
  /**
   * SuccessfulBackupsHistoryLimit specifies how many successful backup jobs and their PVCs to keep after
   * backup completion. Useful for debugging purposes.
   * @type {number}
   * @memberof V1BackupSettings
   */
  successfulBackupsHistoryLimit?: number;
  /**
   * Suspend enables or disables backups (scheduled and ad-hoc). Default: `false`.
   * N.B. Backups are disabled until the Neo4j Database enters `Running` phase.
   * @type {boolean}
   * @memberof V1BackupSettings
   */
  suspend?: boolean;
}

/**
 * Check if a given object implements the V1BackupSettings interface.
 */
export function instanceOfV1BackupSettings(
  value: object,
): value is V1BackupSettings {
  return true;
}

export function V1BackupSettingsFromJSON(json: any): V1BackupSettings {
  return V1BackupSettingsFromJSONTyped(json, false);
}

export function V1BackupSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1BackupSettings {
  if (json == null) {
    return json;
  }
  return {
    backupMemoryOverride:
      json['backupMemoryOverride'] == null
        ? undefined
        : json['backupMemoryOverride'],
    checkConsistency:
      json['checkConsistency'] == null ? undefined : json['checkConsistency'],
    concurrencyLimit:
      json['concurrencyLimit'] == null ? undefined : json['concurrencyLimit'],
    concurrencyPolicy:
      json['concurrencyPolicy'] == null ? undefined : json['concurrencyPolicy'],
    failedBackupsHistoryLimit:
      json['failedBackupsHistoryLimit'] == null
        ? undefined
        : json['failedBackupsHistoryLimit'],
    forceFullBackup:
      json['forceFullBackup'] == null ? undefined : json['forceFullBackup'],
    frequencyMinutes:
      json['frequencyMinutes'] == null ? undefined : json['frequencyMinutes'],
    fullRetentionBackupIntervalMinutes:
      json['fullRetentionBackupIntervalMinutes'] == null
        ? undefined
        : json['fullRetentionBackupIntervalMinutes'],
    gdsTimeoutMinutes:
      json['gdsTimeoutMinutes'] == null ? undefined : json['gdsTimeoutMinutes'],
    retentionDays:
      json['retentionDays'] == null ? undefined : json['retentionDays'],
    runBackupDiagnostics:
      json['runBackupDiagnostics'] == null
        ? undefined
        : json['runBackupDiagnostics'],
    successfulBackupsHistoryLimit:
      json['successfulBackupsHistoryLimit'] == null
        ? undefined
        : json['successfulBackupsHistoryLimit'],
    suspend: json['suspend'] == null ? undefined : json['suspend'],
  };
}

export function V1BackupSettingsToJSON(json: any): V1BackupSettings {
  return V1BackupSettingsToJSONTyped(json, false);
}

export function V1BackupSettingsToJSONTyped(
  value?: V1BackupSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    backupMemoryOverride: value['backupMemoryOverride'],
    checkConsistency: value['checkConsistency'],
    concurrencyLimit: value['concurrencyLimit'],
    concurrencyPolicy: value['concurrencyPolicy'],
    failedBackupsHistoryLimit: value['failedBackupsHistoryLimit'],
    forceFullBackup: value['forceFullBackup'],
    frequencyMinutes: value['frequencyMinutes'],
    fullRetentionBackupIntervalMinutes:
      value['fullRetentionBackupIntervalMinutes'],
    gdsTimeoutMinutes: value['gdsTimeoutMinutes'],
    retentionDays: value['retentionDays'],
    runBackupDiagnostics: value['runBackupDiagnostics'],
    successfulBackupsHistoryLimit: value['successfulBackupsHistoryLimit'],
    suspend: value['suspend'],
  };
}
